<template>
    <v-form>
        <v-card>
            <v-card-title>
                Signos vitales
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Peso"
                            v-model="peso"
                            type="number"
                            step="0.1"
                            filled
                            rounded
                            dense
                            suffix="kg"
                        />
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Talla"
                            v-model="talla"
                            type="number"
                            step="0.1"
                            filled
                            rounded
                            dense
                            suffix="cm"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Temperatura"
                            v-model="temperatura"
                            type="number"
                            step="0.1"
                            filled
                            rounded
                            dense
                            suffix="°C"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Frecuencia cardíaca"
                            v-model="frecuenciaCardiaca"
                            type="number"
                            filled
                            rounded
                            dense
                            suffix="ppm"
                        />
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Frecuencia respiratoria"
                            v-model="frecuenciaRespiratoria"
                            type="number"
                            filled
                            rounded
                            dense
                            suffix="rpm"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Dextrosa capilar"
                            v-model="dextrosaCapilar"
                            type="number"
                            filled
                            rounded
                            dense
                            suffix="mg/dL"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="T.A.S."
                            v-model="presionSistolica"
                            type="number"
                            filled
                            rounded
                            dense
                            suffix="mmHg"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="T.A.D."
                            v-model="presionDiastolica"
                            type="number"
                            filled
                            rounded
                            dense
                            suffix="mmHg"
                        />
                    </v-col>

                    <v-col cols="12">
                        <v-textarea
                            label="Observaciones"
                            v-model="observaciones"
                            filled
                            rounded
                            dense
                        />
                    </v-col>
                    <v-col cols="12" class="text-center">
                    <div class="text--primary">
                    Creado por<br>
                    {{ signos.creadoCompleto}}
                    </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="red" text @click="cerrar">Cerrar</v-btn>
                <v-btn color="teal darken-1" rounded dark @click="guardaSignos">
                    Guardar signos
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
import Swal from "sweetalert2"
import 'sweetalert2/dist/sweetalert2.min.css'
export default {
  data() {
    return {
    peso: '',
    talla: '',
    temperatura: '',
    frecuenciaCardiaca: '',
    frecuenciaRespiratoria: '',
    dextrosaCapilar: '',
    presionSistolica: '',
    presionDiastolica: '',
    observaciones: ''
    }
  },
  methods: {
    cerrar() {
    this.$emit('cerrar')
    },
    async guardaSignos(){
        try {
        const response = await this.$http({
        url: 'somatometria/guardasignos',
        method: 'POST',
        params: {
        cip: this.signos.cip,
        peso: this.peso,
        talla: this.talla,
        temp: this.temperatura,
        taS: this.presionSistolica,
        taD: this.presionDiastolica,
        fc: this.frecuenciaCardiaca,
        fr: this.frecuenciaRespiratoria,
        dext: this.dextrosaCapilar,
        observaciones: this.observaciones,
        creado:this.$store.state.security.usuario
        }
      })
      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Signos vitales guardados correctamente'
        })

      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar signos vitales'
        })
      }
    }
      catch (err) {
        console.error('Error al guardar signos vitales:', err)
        this.$toast.error('Error al guardar signos vitales')
      }
    this.$emit('guardado')

    }
  },
   props: {
    signos: {
    type: Object,
    default: () => ({})
    }
},
/*mounted() {
if (this.signos) {
    this.peso = this.signos.peso || ''
    this.talla = this.signos.talla || ''
    this.temperatura = this.signos.temp || ''
    this.frecuenciaCardiaca = this.signos.fc || ''
    this.frecuenciaRespiratoria = this.signos.fr || ''
    this.dextrosaCapilar = this.signos.dext || ''
    this.presionSistolica = this.signos.taS || ''
    this.presionDiastolica = this.signos.taD || ''
    this.observaciones = this.signos.observaciones || ''
}
}
*/
watch: {
  signos: {
    immediate: true,
    handler(newVal) {
      if (newVal) {
        this.peso = newVal.peso || ''
        this.talla = newVal.talla || ''
        this.temperatura = newVal.temp || ''
        this.frecuenciaCardiaca = newVal.fc || ''
        this.frecuenciaRespiratoria = newVal.fr || ''
        this.dextrosaCapilar = newVal.dext || ''
        this.presionSistolica = newVal.taS || ''
        this.presionDiastolica = newVal.taD || ''
        this.observaciones = newVal.observaciones || ''
      }
    }
  }
}
}
</script>